import { combineReducers } from 'redux'
import deliveryReducer from './delivery'

const reducers = combineReducers({
  deliveryReducer
})

export default reducers
